import { render } from "./SetThePayerModal.vue?vue&type=template&id=1fd92f77&scoped=true"
import script from "./SetThePayerModal.vue?vue&type=script&lang=js"
export * from "./SetThePayerModal.vue?vue&type=script&lang=js"

import "./SetThePayerModal.vue?vue&type=style&index=0&id=1fd92f77&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd92f77"]])

export default __exports__